var shoppingBagEnum = {
    CART: {
        enumName: 'CART',        
        name: 'Carrinho',        
        description: function() {
            return "Meu carrinho";
        },
        shoppingBagEmpty: function() {
            return "Seu carrinho está vazio";
        },
        icon: function() {
            return "pe-7s-cart"
        }
    },
    BAG: {
        enumName: 'BAG',        
        name: 'Sacola',        
        description: function() {
            return "Minha sacola";
        },
        shoppingBagEmpty: function() {
            return "Sua sacola está vazia";
        },
        icon: function() {
            return "pe-7s-shopbag";
        }
    },
    get(value) {               
        if(value === null)
            return shoppingBagEnum.CART;

        var array = Object.values(shoppingBagEnum);
        var shoppingBagFound = {};

        array.forEach(element => {            
            if(element.enumName === value) {                
                shoppingBagFound = element;      
                return ;          
            }            
        });   
        
        return shoppingBagFound;
    },
    list() {
        var array = Object.values(shoppingBagEnum);
        var shoppingBagList = [];

        var shoppingBag = {};        

        shoppingBag.valor = 0;
        shoppingBag.texto = 'Selecione';

        shoppingBagList.push(shoppingBag);        

        array.forEach(element => {            
            if((element.name === 'get')||(element.name === 'list'))
                return ;

            var shoppingBag = {};

            shoppingBag.valor = element.enumName;
            shoppingBag.texto = element.name;

            shoppingBagList.push(shoppingBag);
        });

        return shoppingBagList;
    }
}

export default shoppingBagEnum;